import { Badge, Col, Descriptions, Divider, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  resetNewLogsCounter,
  selectFullMidservice as selectFullInstance,
  selectNewLogs,
} from "../../redux/slices/midservice/midserviceSlice";
import {
  type InstanceLogsType,
  type ModulesStatistics,
} from "../../redux/slices/midservice/midserviceTypes";
import { ConfigurationForm, type FieldData } from "./ConfigurationForm";
import { InstanceStatus } from "./InstanceStatus";
import { MidserviceMessagesTab } from "../../components/MidserviceMessagesTab";
import { DeviceDescription } from "../../components/DeviceDescription";
import { objectToYaml } from "../../utils/yaml";
import { objectToJson } from "../../utils/json";
import { LogsTab } from "../LogsTab";

export const MidservicePage = (): JSX.Element => {
  const fullInstance = useAppSelector(selectFullInstance);
  const [fields, setFields] = useState<FieldData[]>([]);
  const [logs, setLogs] = useState<InstanceLogsType[]>([]);
  const [apiLogs, setApiLogs] = useState<InstanceLogsType[]>([]);
  const newLogs = useAppSelector(selectNewLogs);
  const dispatch = useAppDispatch();

  const onActiveTabChange = (activeKey: string): void => {
    switch (activeKey) {
      case "logs":
        dispatch(resetNewLogsCounter());
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    console.log("fullInstance", fullInstance);
    if (fullInstance != null) {
      const newFields: FieldData[] = [];
      let key: keyof typeof fullInstance.config;
      for (key in fullInstance.config) {
        if (key === "modules") {
          const modules: any[] = [];
          fullInstance.config[key].forEach((module) => {
            modules.push({
              moduleId: module.id,
              runsCall: module.runs.map(
                (run: { call: string }): string => run.call,
              ),
            });
          });
          newFields.push({
            name: "modulesData",
            value: modules,
          });
          newFields.push({
            name: key,
            value: objectToYaml(fullInstance.config[key], true),
          });
        } else if (key === "diagnostics") {
          newFields.push({
            name: key,
            value: objectToJson(fullInstance.config[key]),
          });
        } else {
          console.log("key", key, fullInstance.config[key]);
          newFields.push({ name: key, value: fullInstance.config[key] });
        }
      }
      console.log("newFields", newFields);
      setFields(newFields);
      if (fullInstance?.logs != null) {
        console.log("fullInstance.logs", fullInstance.logs);
        setLogs(fullInstance.logs);
      }
      if (fullInstance?.apiLogs != null) {
        setApiLogs(fullInstance.apiLogs);
      }
    }
  }, [fullInstance]);

  // const restartInstance = () => {
  //   console.log('onclick restartInstance')
  //   const params: RestartReauestType = {toHost: fullInstance.midserviceInstance.deviceId}
  //   API.restartInstance(params);
  // }

  const getStatistics = (modules: any[] | undefined): ModulesStatistics => {
    if (modules == null) return {};

    const result = {
      chequesCount: 0,
      chequesSum: 0,
      skuCount: 0,
      inventoryCount: 0,
      eventsCount: 0,
    };

    for (let i = 0; i < modules.length; i++) {
      result.chequesCount += Number(modules[i]?.statistics?.cheques_count);
      result.chequesSum += Number(modules[i]?.statistics?.cheques_sum);
      result.skuCount += Number(modules[i]?.statistics?.sku_count);
      result.inventoryCount += Number(modules[i]?.statistics?.inventory_count);
      result.eventsCount += Number(modules[i]?.statistics?.events_count);
    }
    return result;
  };

  const statistics = getStatistics(
    fullInstance?.midserviceInstance?.status?.modules,
  );

  return (
    <>
      <Row gutter={[48, 40]} style={{ height: "calc(100vh - 7rem)" }}>
        <Col span={16}>
          <Tabs
            defaultActiveKey="1"
            onChange={onActiveTabChange}
            items={[
              {
                key: "config",
                label: "Конфигурация",
                children: (
                  <ConfigurationForm
                    fields={fields}
                    onChange={(newFields) => {
                      setFields(newFields);
                    }}
                  />
                ),
              },
              {
                key: "logs",
                label: (
                  <Badge size="small" count={newLogs} offset={[10, 0]}>
                    Логи
                  </Badge>
                ),
                children: (
                  <LogsTab
                    fullDeviceId={
                      fullInstance?.midserviceInstance.deviceId ?? ""
                    }
                    midserviceType={
                      fullInstance?.midserviceInstance.instanceType ??
                      "MIDSERVICE"
                    }
                    logs={logs}
                    apiLogs={apiLogs}
                    domain={fullInstance?.midserviceInstance.domain}
                  />
                ),
              },
              {
                key: "status",
                label: "Статус",
                children: <InstanceStatus />,
              },
              {
                key: "interaction",
                label: "Взаимодействие",
                children: <MidserviceMessagesTab />,
              },
            ]}
          ></Tabs>
        </Col>
        <Col span={8} style={{ borderLeft: "1px solid #d9d9d9" }}>
          <DeviceDescription
            fullInstance={fullInstance}
            instanceType="midservice"
          />
          <Divider />
          <Descriptions title={"Статистика"} column={1}>
            <Descriptions.Item label="Кол-во чеков">
              {statistics.chequesCount}
            </Descriptions.Item>
            <Descriptions.Item label="Сумма по чекам">
              {statistics.chequesSum}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во позиций номенклатуры">
              {statistics.skuCount}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во позиций остатков">
              {statistics.inventoryCount}
            </Descriptions.Item>
            <Descriptions.Item label="Кол-во событий">
              {statistics.eventsCount}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </>
  );
};
